module.exports = __webpack_public_path__ + "img/Theia_Clinical_Research_LLC_logo.e405ff0f.svg";